module.exports = __webpack_public_path__ + "img/right-arrow-white.14123b3d.png";